<template>
  <div class="main-layout predicted-item-page">
    <el-card class="box-inner box-bg">
      <c-title slot="header" title="应征入伍"></c-title>
      <div class="div-scroll">
        <div class="form-container">
          <el-form
            :model="form"
            ref="ruleForm"
            label-width="130px"
            label-position="left"
          >
            <el-form-item label="是否已应征入伍">
              <el-switch
                v-model="form.isOrNot"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
            <div class="tips-container">
              <div class="tips">
                <div class="title">
                  <i class="el-icon-info"></i><span>温馨提示</span>
                </div>
                <!-- 否 -->
                <p>
                  1.若您未应征入伍，请选择"否"，提交后继续完成其他预报到事项。
                </p>

                <p>
                  2.若您已应征入伍，请选择"是"，提交后则无需办理其他预报到事项。
                  <!-- 2.若您已应征入伍，请您下载表格模板，自行打印填写完成后，凭纸质材料，到当地人武部审核签字盖章，并由人武部寄回学校。 -->
                </p>
              </div>
              <div class="template-download" v-show="form.isOrNot">
                <a :href="link">点击下载申请表模板</a>
              </div>
            </div>
            <el-form-item>
              <el-button type="primary" @click="submit()" :disabled="isSubmit"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SUCCESS_CODE: "",
      link: "http://yx.ezu.cn/static/welcome/应征入伍普通高等学校录取新生保留入学资格申请表.doc",
      form: { isOrNot: 0 },
      studentId: "",
      forecastLinkId: "",
      isSubmit: false,
      status: "",
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.studentId = JSON.parse(localStorage.getItem("userInfo")).number;
    this.forecastLinkId = this.$route.params.id;
    this.form.isOrNot =
      this.$route.params.isOrNot == "null"
        ? 0
        : Number(this.$route.params.isOrNot);
    console.log(this.form.isOrNot);
    this.status = this.$route.params.status;
  },
  mounted() {
    if (this.status == 0) {
      this.$confirm("请确认是否已应征入伍", "请确认", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        showClose: false,
        type: "warning",
        center: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
      })
        .then(() => {
          console.log("是");
          this.form.isOrNot = 1;
          // this.$message.warning("请按求上报相关表单至相关部门！");
          // this.handleConfirm();
          // 确认已应征入伍后直接下载表格
          // window.location.href = this.link;
        })
        .catch(() => {
          console.log("否");
          this.form.isOrNot = 0;
          this.handleConfirm();
        });
    }
  },
  methods: {
    submit() {
      this.$confirm("请确认无误后提交，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleConfirm();
        })
        .catch(() => {});
    },
    handleConfirm() {
      this.isSubmit = true;
      let params = {
        studentId: this.studentId,
        forecastLinkId: this.forecastLinkId,
        isOrNot: this.form.isOrNot,
      };
      this.$http
        .post("/welcome-live/student/forecast/isOrNot", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.goBack();
          } else {
            this.$message.error("提交失败");
          }
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error("提交失败", err);
          this.isSubmit = false;
        });
    },
    goBack() {
      this.$message.success("提交成功");
      this.$router.replace("/welcome/student/predicted");
    },
  },
};
</script>
